import React, { Component } from 'react';
import SideBar from './SideBar';
import Loading from './Loading';
import { _getToken, _post, _Alert, _setTime, variable, _isLogin } from './Function';
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../css/ChangePassword.css';

const $ = window.$;

class Guarantor extends Component {
    constructor() {
        super();
        this.state={ 
            loadingShow: false,
            password: '',
            re_password: ''
        };
        _isLogin().then( value => { });
    }

    onAddTime = () => { _setTime() }

    update = (t, e) => {
        if ( !isNaN(e.target.value) ) this.setState({ [t]: e.target.value });
    }

    eyeControlPassword() {
        if ( this.state.show_password ) {
            $("#new-password").removeClass("set-password");       
            return <i className="far fa-eye c-show" onClick={(e) => this.setEyeControl('new-password')}></i>;
        } else {
            $("#new-password").addClass("set-password");
            return <i className="far fa-eye-slash c-hide" onClick={(e) => this.setEyeControl('new-password')}></i>;
        }
    }

    eyeControlRePassword() {
        if ( this.state.show_re_password ) {
            $("#re-password").removeClass("set-password");
            return <i className="far fa-eye c-show" onClick={(e) => this.setEyeControl('re-password')}></i>;
        } else {
            $("#re-password").addClass("set-password");
            return <i className="far fa-eye-slash c-hide" onClick={(e) => this.setEyeControl('re-password')}></i>;
        }
    }

    setEyeControl = (e) => {
        if ( e === "new-password" ) {
            if ( this.state.show_password ) {
                $("#re-password").removeClass("set-password");
                this.setState({ show_password: false });
            } else {
                $("#re-password").addClass("set-password");
                this.setState({ show_password: true });
            }
        } else {
            if ( this.state.show_re_password ) {
                $("#re-password").removeClass("set-password");
                this.setState({ show_re_password: false });
            } else {
                $("#re-password").addClass("set-password");
                this.setState({ show_re_password: true });
            }
        }
    }

    checkPassword = () => {
        if ( this.state.password === '' || this.state.password.length < 6 ) {
            _Alert('กรุณากรอกรหัสผ่าน 6 หลัก');
            return;
        }
        if ( this.state.re_password === '' || this.state.re_password.length < 6 ) {
            _Alert('กรุณากรอกรหัสผ่าน 6 หลักอีกครั้ง');
            return;
        } 
        if ( this.state.password !== this.state.re_password ) {
            _Alert('รหัสผ่านไม่ตรงกัน');
            return;
        }
        this.confirm(); 
    }

    confirm() {
        const MySwal = withReactContent(Swal);
        MySwal.fire({ 
          title: 'ยืนยันการเปลี่ยนรหัสผ่าน ?', 
          text: 'คุณต้องการเปลี่ยนรหัสผ่าน',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          reverseButtons: true
        }).then((result) => {
          if ( result.value ) {
            console.log("%cClick Change Password", "color:white;background-color:gray;padding:2px;");
            this.submit();
          }
        });
    }

    submit() {
        this.setState({ loadingShow: true });
        let param = { token: _getToken(), platform: variable().platform, password: this.state.re_password, via: 'website' };
        _post('change.password.php', param) 
        .then(res => { 
            this.setState({ loadingShow: false });
            if ( res.data.status ) {
                this.setState({ password: '', re_password: '' });
                const MySwal = withReactContent(Swal);
                MySwal.fire({ 
                    title: 'เปลี่ยนรหัสผ่านสำเร็จ', 
                    text: 'สามารถเข้าใช้งานผ่านเว็บไซต์ออนไลน์ด้วยรหัสผ่านใหม่ได้แล้ว',
                    type: 'success'
                }).then((result) => { });
            } else {
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                } else {
                    _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                }
            }

        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }
    
    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <Loading show={this.state.loadingShow} />
                <SideBar onRefresh={false} />
                <div className="content-bar">

                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-user-lock"></i></div>
                            <div className="card-title-text">เปลี่ยนรหัสผ่าน</div>
                        </div>
                        <div className="card-content">
                            <div className="pass-row">
                                <div className="input-group mb-3 txt-input changePassword">
                                    <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-unlock-alt"></i></span>
                                    </div>
                                    <InputMask className="form-control" id="new-password" mask="999999" maskChar={null} placeholder="รหัสผ่าน" value={this.state.password} onChange={(e) => this.update("password", e)} />
                                    {this.eyeControlPassword()}
                                </div>
                            </div>
                            <div className="pass-row">
                                <div className="input-group mb-3 txt-input changePassword">
                                    <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-key"></i></span>
                                    </div>
                                    <InputMask className="form-control" id="re-password" mask="999999" maskChar={null} placeholder="รหัสผ่านอีกครั้ง" value={this.state.re_password} onChange={(e) => this.update("re_password", e)} />
                                    {this.eyeControlRePassword()}
                                </div>
                            </div>
                            <div className="pass-row btn-row">
                                <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.checkPassword()}>เปลี่ยนรหัสผ่าน</button>
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
        );
    }
}

export default Guarantor;